/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByDescription } from './Scaffolding';
import {
    Datagrid,
    TextField,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    UrlField,
    SimpleShowLayout,
    ShowButton,
    ReferenceField,
    ReferenceInput,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import {
    AutocompleteInput,
    BooleanInput,
    TextInput,
} from '../lib/wrappers/Inputs';
import { EditButton } from '../lib/wrappers/actions';
import { EditToolbar } from '../layout/EditToolbar';

export const ProfessionalBodyTypeLabels = {
    pageTitle: 'Professional Body Types',
    heartext: 'Hear text',
    professionalbody_id: 'Professional Body',
};

const ProfessionalBodyTypeInputForm = (source) => {
    const { canEditStaticData } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SimpleForm {...source} toolbar={<EditToolbar />}>
                <TextInput source="id" disabled />
                <br />
                <TextInput source="Title" />
                <br />
                <TextInput source="description" />
                <br />
                <BooleanInput source="current" />
                <br />
                <TextInput source="url" />
                <br />
                <TextInput
                    label={ProfessionalBodyTypeLabels.heartext}
                    source="heartext"
                />
                <br />
                <ReferenceInput
                    label={ProfessionalBodyTypeLabels.professionalbody_id}
                    source="professionalbody_id"
                    reference="ProfessionalBody"
                >
                    <AutocompleteInput optionText="Title" />
                </ReferenceInput>
            </SimpleForm>
        </ReadOnlyContext.Provider>
    );
};

export const ProfessionalBodyTypeList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={ProfessionalBodyTypeLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <br />
                    <TextField source="description" />
                    <br />
                    <BooleanField source="current" />
                    <br />
                    <UrlField source="url" />
                    <br />
                    <ShowButton />
                    <EditButton />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const ProfessionalBodyTypeCreate = (props) => (
    <Create {...props} redirect="edit">
        s<ProfessionalBodyTypeInputForm {...props} />
    </Create>
);

export const ProfessionalBodyTypeEdit = (props) => (
    <Edit title={<ShowTitleByDescription />} {...props}>
        <ProfessionalBodyTypeInputForm {...props} />
    </Edit>
);

export const ProfessionalBodyTypeShow = (props) => (
    <Show title={<ShowTitleByDescription />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <br />
            <TextField source="Title" />
            <br />
            <TextField source="description" />
            <br />
            <BooleanField source="current" />
            <br />
            <UrlField source="url" />
            <br />
            <TextField
                label={ProfessionalBodyTypeLabels.heartext}
                source="heartext"
            />
            <br />
            <ReferenceField
                label={ProfessionalBodyTypeLabels.professionalbody_id}
                source="professionalbody_id"
                reference="ProfessionalBody"
            >
                <TextField source="Title" linkType="show" />
            </ReferenceField>
        </SimpleShowLayout>
    </Show>
);
